module.exports = __webpack_public_path__ + "static/img/cup_purple.0858e7c2.png";